module.exports = __webpack_public_path__ + "media/src/images/file-upload-complete-2cb01f60f2380e529586b639e0cc038b.png";